import { Component, Prop, h } from '@stencil/core';

export type SpaceOptions = 'xs' | 'sm' | 'md' | 'lg';

@Component({
  tag: 'uui-spacer-y',
  shadow: true
})
export class UuiSpacerY {
  /** sets the height of the spacer */
  @Prop({ reflect: true }) space: SpaceOptions = "md";

  render() {
    return (
      <uui-spacer y={this.space}>
      </uui-spacer>
    );
  }
}
